import EnquiryController from './enquiry-controller'

export default EnquiryController
